<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        :type-id="formFieldType.checkbox"
        :label="local.prisonerInformation.prisoner"
        :technical-name="`isPrisoner${suggestedTechnicalName}`"
        :value.sync="formModel[`isPrisoner${suggestedTechnicalName}`]"
        :disabled="isDisabled"
        @change="resetData"
      ></naj-input>
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        v-if="formModel[`isPrisoner${suggestedTechnicalName}`]"
        :type-id="formFieldType.text"
        :label="local.prisonerInformation.prisonerNumber"
        :technical-name="`prisonerNo${suggestedTechnicalName}`"
        :value.sync="formModel[`prisonerNo${suggestedTechnicalName}`]"
        :disabled="isDisabled"
      ></naj-input>
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <naj-input
        v-if="formModel[`isPrisoner${suggestedTechnicalName}`]"
        :type-id="formFieldType.text"
        :label="local.prisonerInformation.prisonName"
        :technical-name="`prisonName${suggestedTechnicalName}`"
        :value.sync="formModel[`prisonName${suggestedTechnicalName}`]"
        :disabled="isDisabled"
      ></naj-input>
    </v-col>
  </v-row>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'viewMode', 'isDisabled', 'suggestedTechnicalName'],
  methods: {
    resetData() {
      if (!this.formModel[`isPrisoner${this.suggestedTechnicalName}`]) {
        this.$set(this.formModel, `prisonerNo${this.suggestedTechnicalName}`, null);
        this.$set(this.formModel, `prisonName${this.suggestedTechnicalName}`, null);
      }
    },
  },
};
</script>
